<template>
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span class="crumb" @click="$router.push({path: '/'})">首页</span>
        <span>></span>
        <span
          class="crumb"
          @click="$router.push({name: 'single_copy',
        params: { title: '单行本', isActive: 1 }
      })"
        >购买记录</span>
        <span>></span>
        <span
          class="crumb"
          @click="$router.push({name: 'single_copy',
        params: { title: title, isActive: flag }
      })"
        >{{title}}</span>
        <span>></span>
        <span>开票</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="top-nav">
            <ul>
              <li
                v-for="(item,i) in navList"
                :key="i"
                :class="i==isActive?'actives':''"
                @click="change(i,item.title)"
              >{{item.title}}</li>
            </ul>
          </div>
          <div>
            <div class="invoiceInfo">
              <el-form label-width="100px" class="demo-ruleForm">
                <el-row>
                  <el-col :span="10">
                    <el-form-item>
                      <p>开票状态</p>
                      <el-input v-model="statue" disabled></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="10" class="right">
                    <el-form-item>
                      <p>申请时间</p>
                      <el-input v-model="finishList.created_at" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <el-form-item>
                      <p>发票抬头</p>
                      <el-input v-model="finishList.name" disabled></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="10" class="right">
                    <el-form-item>
                      <p>税号</p>
                      <el-input v-model="finishList.tax_num" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <el-form-item>
                      <p>联系人</p>
                      <el-input v-model="finishList.drawer" disabled></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="10" class="right">
                    <el-form-item>
                      <p>邮寄地址</p>
                      <el-input v-model="finishList.ship_address" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <el-form-item>
                      <p>联系电话</p>
                      <el-input v-model="finishList.ship_phone" disabled></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="10" class="right">
                    <el-form-item>
                      <p>总金额</p>
                      <el-input v-model="finishList.amount" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
        <div class="content-r">
          <DropDownMenu></DropDownMenu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DropDownMenu from "@/components/dropDownMenu";
import { getVoiceDetailList } from "@/api/system";
import { getTdkList} from "@/api/tdk";
export default {
  components: {
    DropDownMenu
  },
  data() {
    return {
      title: "",
      isActive: 1,
      navList: [{ title: "订阅" }, { title: "单行本" }, { title: "音频" }],
      // 开票列表
      finishList: {},
      statue: "已申请"
    };
  },
  methods: {
    change(flag, title) {
      this.title = title;
      this.isActive = flag;
      this.$router.push({
        name: "single_copy",
        params: { title: title, isActive: flag }
      });
    },
    filterTime(val) {
      if (val == null || val == "") {
        return;
      } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month =
          d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let times = d.getFullYear() + "年" + month + "月" + day + "日";
        return times;
      }
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    this.title = this.$route.params.title;
    var id = this.$route.params.id;
    this.isActive = this.$route.params.isActive;
    getVoiceDetailList(id).then(res => {
      this.finishList = res.data.data;
      this.finishList.created_at = this.filterTime(this.finishList.created_at);
      this.finishList.amount = this.finishList.amount + "元";
    });
  }
};
</script>
<style lang="scss" scoped>
.content-l{
  min-height: 800px;
}
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
  span:last-child {
    color: #0091ff;
  }
}
.top-nav {
  display: flex;
  background: #ffffff;
  justify-content: space-between;
  line-height: 50px;
  align-items: center;
  padding: 0 30px;
  ul {
    display: flex;
    li {
      font-size: 16px;
      margin-right: 50px;
      color: #999999;
      cursor: pointer;
    }
    .actives {
      color: #0091ff;
      border-bottom: 4px solid;
    }
  }
  .el-button {
    border-radius: 15px;
    background: #0091ff;
    color: #ffffff;
    height: 30px;
    width: 80px;
    padding: 0;
    cursor: pointer;
  }
}
.invoiceInfo {
  background: #ffffff;
  padding: 30px;
  margin: 30px 0;
  .right {
    float: right;
  }
  .el-col-10 {
    width: 44% !important;
  }
  >>> .el-form-item__content {
    margin-left: 0px !important;
    margin-top: 10px;
    p {
      line-height: 20px;
      font-size: 16px;
    }
    .el-input__inner {
      border: none;
      border-bottom: 1px solid #dcdfe6;
      border-radius: 0;
      padding: 0 10px;
    }
  }
  >>> input::-webkit-input-placeholder {
    color: #999999;
    font-size: 14px;
  }

  >>> .el-button--primary {
    border-radius: 18px !important;
    padding: 10px 16px !important;
  }
  >>> .el-button--primary:hover {
    background: #409eff;
    border-color: #409eff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/buyRecords/voiceDetail.vue